<template>
<div class="chapter">
<div class="inner_page">
<section class="titlepage" epub:type="titlepage">
<div class="title_page_image"><img alt="Destiny’s Child by Iris Gower" src="images/scale~1920x1200~destinyschil-1582554119-81.jpg"/></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter0.vue?9ef2d710